/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Content\Car\CarTabs\CarTabs.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday October 8th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday October 8th 2024 2:13:58 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Tab, Tabs } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";
import { useMemo, useState } from "react";
import { useLoaderData } from "react-router-dom";
import { CustomTabPanel } from "Utils/Tabs";
import { indexOf } from "lodash-es";
import CarList from "../CarList/CarList";

export default function CarTabs() {
    const tabs = ["auto-ecole", "courtoisie", "utilitaire"];
    const loadData = useLoaderData() as {tabkey?: string};
    const [tabIdx, setTabIdx] = useState(loadData.tabkey ? indexOf(tabs, loadData.tabkey) : 0);

    const handleChange = (event: React.SyntheticEvent, idx: number) => {
        setTabIdx(idx);
        const url = window.location;
        const searchParams = new URLSearchParams(url.search);
        searchParams.set("tabkey", tabs[idx]);
        window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
    };

    const buildTabs = () => {
        const myTabs: JSX.Element[] = [];
        for (let i = 0; i < tabs.length; ++i)
            myTabs.push(<Tab value={i} label={translator.decode(`car.${tabs[i]}`)} />);
        return myTabs;
    };

    const buildRows = () => {
        const rows: JSX.Element[] = [];
        for (let i = 0; i < tabs.length; ++i)
            rows.push(<CustomTabPanel key={`tabPanel-${tabs[i]}`} value={tabIdx} index={i} idlabel={`${tabs[i]}`} aria={`Display all cars from ${tabs[i]} category`}>
                <CarList category={tabs[i]} />
            </CustomTabPanel>);
        return rows;
    };

    const carPage = useMemo(() => {
        return buildRows();
    }, [tabIdx]);

    return (
        <>
            <Tabs value={tabIdx} onChange={handleChange} variant="fullWidth" aria-label="Tabs to display Car List based on their categories" >
                {buildTabs()}
            </Tabs>
            {carPage}
        </>
    );
};
